import { Modal } from "@xola/ui-kit";
import { SecondaryButton } from "common";
import React from "react";

interface MultiFactorAuthenticationForBankInfoModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const MultiFactorAuthenticationForBankInfoModal = ({
    isOpen,
    onClose,
}: MultiFactorAuthenticationForBankInfoModalProps) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <Modal.Header>Primary Account MFA Required</Modal.Header>

            <Modal.Body>
                <p className="mb-3">
                    This field is protected by Multi Factor Authentication (MFA) from the <b>primary account owner.</b>
                </p>
                <p>
                    Please contact the primary account owner and have them configure MFA for this account in order to
                    proceed.
                </p>
            </Modal.Body>

            <Modal.Footer className="space-x-4">
                <SecondaryButton onClick={onClose}>Close</SecondaryButton>
            </Modal.Footer>
        </Modal>
    );
};
